import { createSelector } from "@reduxjs/toolkit";
import { memoize } from "lodash";

export const getApplicationsForJob = createSelector(
  (state) => state.applications.data || [],
  (applications) => memoize((jobId) => applications.filter((i) => i.jobId.toString() === jobId.toString()))
);

export const getApplicationsForUser = createSelector(
  (state) => state.applications.data || [],
  (applications) => memoize((userId) => applications.filter((i) => (i.userId?.toString() === userId.toString()) || (i.user?.id?.toString() === userId.toString())))
);